module.exports = __webpack_public_path__ + "static/img/phone1.1acda52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/software/images/phone1.png
// module id = sGaT
// module chunks = 1